<template>
	<el-dialog title="会议室详情" :visible.sync="dialogVisible" width="60%" :before-close="resetform">
		<div class="hui_info padding-lr-38" style="height:88vh;overflow-y: auto;">
			
			<div class="room flex padding-top-28 padding-bottom-40">
				<!-- <img class="hys_pic" src="../../../../assets/room.png" style="width:160px;height: 80px;"></img> -->
				<div class="room_right margin-left-26" v-if="detail">
					<div class="room_name color-33 font10">
						{{detail.name}}
					</div>
					<div class="room_cont flex-aic" style="margin: 10px 0;">
						<i class="el-icon-location-outline" style="color: #277BF5;font-size: 16px;"></i>
						<span class="font7 color-a2">地点：{{detail.address}}</span>
					</div>
					<div class="room_cont flex-aic">
						<i class="el-icon-user" style="color: #277BF5;font-size: 16px;"></i>
						<span class="font7 color-a2">联系人：{{detail.username}} {{detail.phone}}</span>
					</div>
				</div>
			</div>
			
			
			<div style="color: #277BF5;font-size: 0.3rem;">{{nowdate}}&nbsp;&nbsp;&nbsp;&nbsp;{{nowweek}}</div>
			<div class="hy_info_title flex-aic flex-sb" v-if="roomList.length>0">				
				<el-calendar :range="[roomList[0].time, roomList[roomList.length-1].time]" v-model="value">
					<template
					    slot="dateCell"
					    slot-scope="{date, data}">
					    <p :class="data.isSelected ? 'is-selected' : ''">
					      {{ data.day.split('-').slice(1).join('-') }}
					    </p>
						<p style="margin-top: 10px;"></p>
						<p :style="{color: showtipssw(data.day)?'#F5BE41':'#BFD8FF',fontSize: '12px'}">{{showtipssw(data.day)?'已满':'空闲'}}</p>						
					  </template>
				</el-calendar>
			</div>
			<div class="colorShili padding-lr-40" >
				<div class="flex-aic color-82878D ">
					<div class="kuai">
						
					</div>
					可预订
				</div>
				<div class="flex-aic color-82878D">
					<div class="kuai kuai2">
						
					</div>
					已预订
				</div>
			</div>
			
			<div class="room_bottom">
				<div class="room_zt">
					<div class="">
						<div class="room_zt_name flex flex-aic">
							<!-- <span class="padding-right-50 font9 fontweight400 color-25">上午</span> -->
							<div class="room_active flex1" :class="nowinfo&&nowinfo.w?'room_active':'room_no'">
								
							</div>
						</div>
					</div>
					<div class="room_info" v-if="nowinfo&&nowinfo.w">
						<div class="font8 fontweight400 color-6d">
							预定部门：{{nowinfo.w.yyrbumen}}
						</div>
						<div  class="font8 fontweight400 color-6d">
							会议名称：{{nowinfo.w.name}}
						</div>
					</div>
				</div>
				
				<!-- <div class="room_zt room_zt_xw">
					<div class="">
						<div class="room_zt_name flex flex-aic">
							<span class="padding-right-50 font9 fontweight400 color-25">下午</span>
							<div class=" flex1" :class="nowinfo&&nowinfo.xw?'room_active':'room_no'">
								
							</div>
						</div>
					</div>
					<div class="room_info" v-if="nowinfo&&nowinfo.xw">
						<div class="font8 fontweight400 color-6d">
							预定部门：{{nowinfo.xw.yyrbumen}}
						</div>
						<div  class="font8 fontweight400 color-6d">
							会议名称：{{nowinfo.xw.name}}
						</div>
					</div>
				</div> -->
			</div>
			
			
		</div>
	</el-dialog>
</template>

<script>
	import dayjs from 'dayjs'
	export default{
		data(){
			return{
				nowdate:'',
				nowweek:'',
				value: new Date(),
				dialogVisible:false,
				radiovalue1:-1,
				addr:'',
				roomList:[],
				starttime:'',
				id:'',
				detail:'',
				nowinfo:{
					sw:'',
					xw:''
				}
			}
		},
		created(){
			var customParseFormat = require('dayjs/plugin/customParseFormat')
			dayjs.extend(customParseFormat)
			this.nowdate = dayjs().format('YYYY-MM-DD')
			this.starttime = this.nowdate
			this.nowweek = this.getWeekDate()
			
		},
		watch:{
			value(newval,oldval){
				this.starttime = dayjs(newval).format('YYYY-MM-DD')
				this.getlist()
				this.roomList.forEach((item,index)=>{
					if(item.time==dayjs(newval).format('YYYY-MM-DD')){
						this.nowinfo = JSON.parse(JSON.stringify(item))
					}
				})
			}
		},
		methods:{
			showtipssw(time){
				let info=false
				this.roomList.forEach((item,index)=>{
					if(item.time==time){
						if(item.w){
							info=true
						}
					}
				})
				return info
			},
			showtipsxw(time){
				let info=false
				this.roomList.forEach((item,index)=>{
					if(item.time==time){
						if(item.xw){
							info=true
						}
					}
				})
				return info
			},
			getdetail(){
				this.$post({
					url: '/api/invest_research_room/details',
					params: {
						id:this.id
					}
				}).then((res) => {
					this.detail = res
				})
			},
			getWeekDate(time = new Date()) {
				let weeks = new Array("星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六");
				
				let date = new Date(time);
				let day = date.getDay();
				console.log(weeks[day])
				return weeks[day];
			},

			resetform(){
				this.dialogVisible = false
			},
			getlist(){
				let riqistr = this.starttime.split('-')
				this.$post({
					url: '/api/invest_research_roomrq/index',
					params: {
						nian:riqistr[0],
						yue:riqistr[1],
						room_id:this.id
					}
				}).then((res) => {
					this.roomList = res.list					
					this.roomList.forEach((item2)=>{
						if(item2.time==this.starttime){
							this.nowinfo = JSON.parse(JSON.stringify(item2))
						}
					})
				})
			},
			isselect(item){
				console.log(this.starttime)
				let hour = parseInt(this.starttime.substring(11, 13));
				console.log(hour)
				let falg = false
				if (hour >= 12&&item.xw) {
				  falg = true
				}
				if(hour<12&&item.sw){
				  falg = true
				}
				return falg
			},
			radioChange(n) {
				let hour = parseInt(this.starttime.substring(11, 13));				
				if (hour >= 12&&n.xw) {
					return false
				}
				if(hour<12&&n.sw){
					return false
				}				
				
				this.radiovalue1 = n.id
				this.addr = n.address
				this.$emit('seletedroom',{id:this.radiovalue1,addr:this.addr})
				this.dialogVisible = false
			},
			linkHuiyishiRili(){
				
			}
		}
	}
</script>

<style lang="scss" scoped>
	* {
		box-sizing: border-box;
	}
	
	html {
		-webkit-text-size-adjust: 100%;
		-webkit-tap-highlight-color: transparent;
	}
	
	body {
		margin: 0;
		-webkit-overflow-scrolling: touch;
		background-color: #f5f5f5;
	}
	
	h1,
	h2,
	h3,
	h4,
	h5,
	h6,
	p,
	ul,
	ol,
	dl,
	input,
	button,
	select,
	optgroup,
	textarea {
		margin: 0;
		padding: 0;
	}
	
	input,
	textarea,
	select,
	button {
		font: 14px 'PingFangSC-Regular', 'monospace', 'sans', 'serif', 'Microsoft YaHei';
	}
	
	i {
		font-style: normal;
	}
	
	ol,
	ul,
	dl {
		list-style: none;
	}
	
	a {
		text-decoration: none;
	}
	
	input {
		background: none;
		outline: none;
		border: 0px;
	}
	
	img {
		vertical-align: middle;
		border-style: none;
	}
	
	a,
	area,
	button,
	label,
	select,
	textarea {
		-ms-touch-action: manipulation;
		touch-action: manipulation;
	}
	
	table {
		border-collapse: collapse;
	}
	
	label {
		display: inline-block;
	}
	
	radio {
		transform: scale(0.7)
	}
	
	button,
	html [type="button"],
	[type="reset"],
	[type="submit"] {
		-webkit-appearance: button;
	}
	
	page {
		background-color: #ffffff;
		/* font-family: Microsoft JhengHei; */
	}
	
	/* flex布局 */
	.flex {
		display: flex;
	}
	
	.flex1 {
		flex: 1;
	}
	
	.flex2 {
		flex: 2;
	}
	
	.flex3 {
		flex: 3;
	}
	
	.flex4 {
		flex: 4;
	}
	
	.flex5 {
		flex: 5;
	}
	
	
	.flex-aic {
		display: flex;
		align-items: center;
	}
	
	.flex-sb {
		display: flex;
		justify-content: space-between;
	}
	
	.flex-jc-c {
		display: flex;
		justify-content: center;
	}
	
	.flex-aic-sb {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	
	.flex-aifs-sb {
		display: flex;
		justify-content: space-between;
		align-items: flex-start;
	}
	
	.flex-aic-sa {
		display: flex;
		align-items: center;
		justify-content: space-around;
	}
	
	.flex-aic-c {
		display: flex;
		justify-content: center;
		align-items: center;
	}
	
	.flex-sb-w {
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
	}
	
	.flex-shrink0 {
		flex-shrink: 0;
	}
	
	.flex-shrink1 {
		flex-shrink: 1;
	}
	
	
	.flex-c {
		display: flex;
		flex-direction: column;
	}
	
	.flex-c-start {
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
	}
	.flex-jcfs{
		display: flex;
		justify-content: flex-start;
	}
	
	
	
	
	/* 字体大小 */
	.font5 {
		font-size: 10px
	}
	
	.font6 {
		font-size: 12px
	}
	
	.font7 {
		font-size: 14px
	}
	
	.font8 {
		font-size: 16px
	}
	
	.font9 {
		font-size: 18px
	}
	
	.font10 {
		font-size: 20px
	}
	
	.font11 {
		font-size: 22px
	}
	
	.font12 {
		font-size: 24px
	}
	
	.font13 {
		font-size: 26px
	}
	
	.font14 {
		font-size: 28px
	}
	
	.font15 {
		font-size: 30px
	}
	
	.font16 {
		font-size: 32px;
	}
	
	.font17 {
		font-size: 34px;
	}
	
	.font18 {
		font-size: 36px;
	}
	
	.font20 {
		font-size: 40px;
	}
	
	.font22 {
		font-size: 44px;
	}
	
	.font27 {
		font-size: 54px;
	}
	
	
	/* 字体位置 */
	.text-align-c {
		text-align: center;
	}
	
	.text-align-l {
		text-align: left;
	}
	
	.text-align-r {
		text-align: right;
	}
	
	/* margin */
	.margin-top-8 {
		margin-top: 8px;
	}
	.margin-top-10 {
		margin-top: 10px;
	}
	
	
	.margin-top-12 {
		margin-top: 12px;
	}
	
	.margin-top-16 {
		margin-top: 16px;
	}
	
	.margin-top-26 {
		margin-top: 26px;
	}
	
	.margin-top-30 {
		margin-top: 30px;
	}
	
	.margin-top-32 {
		margin-top: 32px;
	}
	
	.margin-top-40 {
		margin-top: 40px;
	}
	
	.margin-top-46 {
		margin-top: 46px;
	}
	
	
	.margin-bottom-4 {
		margin-bottom: 4px;
	}
	
	
	.margin-bottom-12 {
		margin-bottom: 12px;
	}
	
	.margin-bottom-16 {
		margin-bottom: 16px;
	}
	
	.margin-bottom-18 {
		margin-bottom: 18px;
	}
	
	.margin-bottom-20 {
		margin-bottom: 20px;
	}
	
	.margin-bottom-26 {
		margin-bottom: 26px;
	}
	
	.margin-bottom-28 {
		margin-bottom: 28px;
	}
	
	
	
	.margin-right-6 {
		margin-right: 6px;
	}
	
	
	.margin-right-8 {
		margin-right: 8px;
	}
	
	
	.margin-right-10 {
		margin-right: 10px;
	}
	
	
	.margin-right-12 {
		margin-right: 12px;
	}
	
	.margin-right-18 {
		margin-right: 18px
	}
	
	.margin-right-24 {
		margin-right: 24px
	}
	
	
	.margin-right-28 {
		margin-right: 28px
	}
	
	
	
	.margin-right-36 {
		margin-right: 36px
	}
	
	
	
	.margin-left-10 {
		margin-left: 10px
	}
	.margin-left-14 {
		margin-left: 14px
	}
	
	.margin-left-26 {
		margin-left: 26px
	}
	
	.margin-lr-42 {
		margin-left: 42px;
		margin-right: 42px;
	}
	
	
	
	/* padding */
	.bs-border {
		box-sizing: border-box;
	}
	
	.padding24 {
		padding: 24px;
	}
	
	.padding36 {
		padding: 36px;
	}
	
	
	
	
	
	.padding-8 {
		padding: 8px;
	}
	
	/* padding上 */
	.padding-top-10 {
		padding-top: 10px;
	}
	
	.padding-top-12 {
		padding-top: 12px;
	}
	
	.padding-top-14 {
		padding-top: 14px;
	}
	
	.padding-top-16 {
		padding-top: 16px;
	}
	
	.padding-top-18 {
		padding-top: 18px;
	}
	
	.padding-top-20 {
		padding-top: 20px;
	}
	
	.padding-top-22 {
		padding-top: 22px;
	}
	
	.padding-top-26 {
		padding-top: 26px;
	}
	
	.padding-top-28 {
		padding-top: 28px;
	}
	
	.padding-top-30 {
		padding-top: 30px;
	}
	
	.padding-top-32 {
		padding-top: 32px;
	}
	
	.padding-top-36 {
		padding-top: 36px;
	}
	
	.padding-top-44 {
		padding-top: 44px;
	}
	
	
	
	.padding-left-12 {
		padding-left: 12px;
	}
	
	
	.padding-left-30 {
		padding-left: 30px;
	}
	
	
	.padding-left-38 {
		padding-left: 38px;
	}
	
	.padding-right-30 {
		padding-right: 30px;
	}
	
	.padding-right-50 {
		padding-right: 50px;
	}
	
	
	
	/* padding下 */
	.padding-bottom-6 {
		padding-bottom: 6px;
	}
	
	.padding-bottom-10 {
		padding-bottom: 10px;
	}
	
	.padding-bottom-14 {
		padding-bottom: 14px;
	}
	
	.padding-bottom-16 {
		padding-bottom: 16px;
	}
	
	.padding-bottom-20 {
		padding-bottom: 20px;
	}
	
	
	
	.padding-bottom-26 {
		padding-bottom: 26px;
	}
	
	.padding-bottom-32 {
		padding-bottom: 32px;
	}
	
	.padding-bottom-40 {
		padding-bottom: 40px;
	}
	
	
	
	/* padding上下 */
	.padding-tb-6 {
		padding-top: 6px;
		padding-bottom: 6px;
	}
	
	.padding-tb-8 {
		padding-top: 8px;
		padding-bottom: 8px;
	}
	
	.padding-tb-10 {
		padding-top: 10px;
		padding-bottom: 10px;
	}
	
	.padding-tb-12 {
		padding-top: 12px;
		padding-bottom: 12px;
	}
	
	.padding-tb-16 {
		padding-top: 16px;
		padding-bottom: 16px;
	}
	
	.padding-tb-22 {
		padding-top: 22px;
		padding-bottom: 22px;
	}
	
	.padding-tb-24 {
		padding-top: 24px;
		padding-bottom: 24px;
	}
	
	.padding-tb-26 {
		padding-top: 26px;
		padding-bottom: 26px;
	}
	
	.padding-tb-28 {
		padding-top: 28px;
		padding-bottom: 28px;
	}
	
	.padding-tb-32 {
		padding-top: 32px;
		padding-bottom: 32px;
	}
	
	.padding-tb-36 {
		padding-top: 36px;
		padding-bottom: 36px;
	}
	
	.padding-tb-50 {
		padding-top: 50px;
		padding-bottom: 50px;
	}
	
	/* padding左右 */
	.padding-lr-10 {
		padding-left: 10px;
		padding-right: 10px;
	}
	
	.padding-lr-12 {
		padding-left: 12px;
		padding-right: 12px;
	}
	
	.padding-lr-14 {
		padding-left: 14px;
		padding-right: 14px;
	}
	
	.padding-lr-16 {
		padding-left: 16px;
		padding-right: 16px;
	}
	
	.padding-lr-18 {
		padding-left: 18px;
		padding-right: 18px;
	}
	
	.padding-lr-20 {
		padding-left: 20px;
		padding-right: 20px;
	}
	
	.padding-lr-22 {
		padding-left: 22px;
		padding-right: 22px;
	}
	
	.padding-lr-24 {
		padding-left: 24px;
		padding-right: 24px;
	}
	
	.padding-lr-26 {
		padding-left: 26px;
		padding-right: 26px;
	}
	
	.padding-lr-28 {
		padding-left: 28px;
		padding-right: 28px;
	}
	
	.padding-lr-32 {
		padding-left: 32px;
		padding-right: 32px;
	}
	
	.padding-lr-34 {
		padding-left: 34px;
		padding-right: 34px;
	}
	
	.padding-lr-37 {
		padding-left: 37px;
		padding-right: 37px;
	}
	
	.padding-lr-38 {
		padding-left: 38px;
		padding-right: 38px;
	}
	
	.padding-lr-40 {
		padding-left: 40px;
		padding-right: 40px;
	}
	
	.padding-lr-50 {
		padding-left: 50px;
		padding-right: 50px;
	}
	
	.padding-lr-60 {
		padding-left: 60px;
		padding-right: 60px;
	}
	
	.padding-lr-66 {
		padding-left: 66px;
		padding-right: 66px;
	}
	
	/* 字体颜色 */
	.color-90 {
		color: #909090;
	}
	
	.color-33 {
		color: #333333;
	}
	
	.color-bd {
		color: #BDBDBD;
	}
	
	.color-fff {
		color: #fff;
	}
	
	.color-6d {
		color: #6d6d6d;
	}
	.color-62 {
		color: #626262;
	}
	
	.color-48 {
		color: #484848;
	}
	
	.color-41 {
		color: #414141;
	}
	
	.color-4b {
		color: #4b4b4b;
	}
	
	.color-02 {
		color: #020202;
	}
	
	.color-2a {
		color: #2A2A2A;
	}
	
	.color-a2 {
		color: #A2A2A2;
	}
	
	
	.color-25 {
		color: #252525;
	}
	
	.color-9b {
		color: #9B9B9B;
	}
	
	.color-A7A1A1 {
		color: #A7A1A1;
	}
	
	.color-a2a3a4 {
		color: #a2a3a4;
	}
	
	.color-78797B {
		color: #78797B;
	}
	
	.color-277BF5 {
		color: #277BF5;
	}
	
	.color-0 {
		color: #000;
	}
	
	/* 字体加粗 */
	.fontweight400 {
		font-weight: 400
	}
	
	.fontweight500 {
		font-weight: 500
	}
	
	.fontweight600 {
		font-weight: 600
	}
	
	
	.border {
		border: 1px solid #D8D8D8;
	}
	
	/* 文本超出显示省略号 */
	.text-ell-1 {
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
	}
	
	.text-ell-2 {
		text-overflow: -o-ellipsis-lastline;
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		line-clamp: 2;
		-webkit-box-orient: vertical;
	}
	.text-ell-6{
		 text-overflow: -o-ellipsis-lastline;
		  overflow: hidden;
		  text-overflow: ellipsis;
		  display: -webkit-box;
		  -webkit-line-clamp: 6;
		  line-clamp: 6;
		  -webkit-box-orient: vertical;
	}
	
	.width100{
		width: 100%;
	}
	.width60{
		width: 60%;
	}
	.width50{
		width: 50%;
	}
	.width40{
		width: 40%;
	}
	.width30{
		width: 30%;
	}
	.width20{
		width: 20%;
	}
	.hui_info {
		padding-bottom: 20px;
		height: 80vh;
	}
	.colorShili{
		background-color: #fff;
		margin-top: 20rpx;
		margin-bottom: 10rpx;
		display: flex;
		align-items: center;
		justify-content: space-around; 
	}
	.kuai{
		width: 22px;
		height: 22px;
		background-color: #E6EFFD;
		margin-right: 6px;
	}
	.kuai2{
		background-color: #F5BE41;
	}
	::v-deep .el-dialog__body{
		padding-top: 0px !important;
	}
	.shangwu .room_div{
		border-right:1px solid #BFD8FF;;
	}	
	.room_div{
		width: 100%;
		height: 21px;
		background-color: #E6EFFD;
		margin: 14px 0 2px 0;
	}
	.room_info{
		width: 80%;
		background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMwAAABWCAYAAACD33nXAAAAAXNSR0IArs4c6QAABYNJREFUeF7tmt9rm2UUx8+TvEmbpM6utLa61Z9XOkQr4uY2ZiOWDsZkKHizOwXxP5g32nQ3orfeiqI3ggoDh3Nu0lYd2unACSp6IWPauc3WmdmlaZI3eSRuYG217Vn60uR5Pr3NeZ/nnM85X84571sj/EEAAqsmYFZtiSEEICAIhiKAgIIAglHAwhQCCKYJa2BubGiHBNVKetfYl03ontcuIZgmS3/hk6HHbVh+TWpVMYn0M5nBY4ebzEWv3UEwTZJ+a8UUx7NPxJPJ94JN+0SslfDc+1KtlJ5MZccPGSO2SVz12g0E0wTpt6f2pgv56RczPXcdqG3YJbFU399e1YoXJXZ5XAozZ17+s9hz8Ja9h+eawF2vXUAw65z+M28Mtvf0zx9Jdj+UDbq3iwlSIrZ21SsTExvOSfjbZ1K+dHo8c3N+t9nyfXmdXfb6egSzjum3k1t75+Y7vk123d8d9Oxc1pNw+oSUfz99IS3Ve012YmYd3fb66v8VjB0f7BCRIO81nmiCN0FoEuVwpwk2vp3oeTgTdA2I2HD5y2KBhDOnpDJzctaG+f2VZHDChgF7zRqnqPPqeaHJTlz5r6OXCOa7d+5J3tHV/XrNlh6sDwVkZI0zUocqIvFU36a2zXsypr1PxFZXd0l9RCtekPmpDwq1+YvnyM3qsGmsrgnCGtN+Mn3ppqfNU+/+KzlLBDP78SPPBh39r7bfuT8ptYrmLmy1BFYrlMXnmrj2Juw1BGIJKf30ZtEWf30u9einby18dKlgjm092HHbnhfkxvv+WT41l2ELgVYnUO/k+W+kcPbI6A3Dk7nlBfPRtlzm1uERs/EBBNPqicf/6yNQF8wfX0vh56MrC6ZwfNtIavNwDsFcH2uecoCARjCzdBgHMk4IDRHQCIYO0xBqHnaBgEYwdBgXMk4MDRG4Jpji1NFcZmhylKW/IZo87DwBOozzKSbAtSSAYNaSJmc5T0AjGJZ+58uBAFciwA6zEiF+h8ACApoOw1sySsd7AnQY70sAABoCCEZDC1vvCSAY70sAABoCCEZDC1vvCWiWfl4re18uANB0GARDvXhPQCMYXit7Xy4AYCSjBiCgIKDpMIxkCrCYuklAIxhGMjdrgKgUBDQjGYJRgMXUTQIawTCSuVkDRKUgoBnJEIwCLKZuEtB0GEYyN2uAqBQE6DAKWJhCQNNhGMmoF+8JaDoMI5n35QIATYdBMNSL9wQQjPclAAANAY1g2GE0ZLF1kgA7jJNpJaioCGg6DDtMVFng3JYhoBEMI1nLpBVHoyKgEQwdJqoscG7LENAIhg7TMmnF0agIaJZ+BBNVFji3ZQhoOgwjWcukFUejIoBgoiLLuU4SQDBOppWgoiKAYKIiy7lOEkAwTqaVoKIigGCiIsu5ThJAME6mlaCiIoBgoiLLuU4S0Hy45DuMkyVAUBoCdBgNLWy9J6ARDP8a4325AICRjBqAgIIAHUYBC1MI0GGoAQgoCNBhFLAwhYCmw7D0Uy/eE0Aw3pcAADQEEIyGFrbeE9AIhi/93pcLAFj6qQEIKAhoBEOHUYDF1E0CGsHwlszNGiAqBQF2GAUsTCGAYKgBCCgIaEYydhgFWEzdJKARDDuMmzVAVAoCjGQKWJhCQNlhcqn+3SOmc0DE1oAHAf8I1AWTPy3FXz4czQxN5hYCMItpXDm+4/m23u0vBb2DIjYUkSUm/gEkYo8IWJFYIJXzY1Ke/uJAx2Ofv7KsYEpj2S2VaulQovPuXomn20Ws9YgWoXpPwBipFuYrl388X4sn9m3ITvywrGDqPxbHB2+3ldJANVaLS9V7ggDwiUBcJG5iVYm1fZXOTkwtDp15y6diINaGCSCYhhFygE8EEIxP2SbWhgkgmIYRcoBPBP4CkD4hk5HtcdkAAAAASUVORK5CYII=");
		background-repeat: no-repeat;
		background-size: 100% 100%;
		margin-left: 18%;
		    padding: 30px;
		    padding-top: 20px;
		padding-bottom: 10px;
		
	}
	.room_div_sure{
		background-color: #F5BE41;
	}
	.yuding_btn{
		border: 1px solid #d00;
		padding: 3px 9px;
		border-radius: 14px 14px 14px 14px;
		cursor: pointer;
		color: #d00;
	}
	.yuding_btn:hover{
		background-color: #d00;
		color: #fff;
	}
	.room_item{
		border-bottom: 1px solid #eee;
	}
	.activebox{
		padding: 3px 9px;
		border-radius: 14px 14px 14px 14px;
		cursor: pointer;
		background-color: #d00;
		color: #fff;
	}
	.disbtm{
		
		padding: 3px 9px;
		border-radius: 14px 14px 14px 14px;
		cursor: pointer;
		background-color: #A2A2A2;
		border: none;
		color: #666;
	}
	.room_bottom{
		padding: 36px 23px 25px 23px;
		background-color: #fff;
	}
	::v-deep .el-dialog{
		margin: 0 !important;
	}
	.room_active{
		height: 33px;
		background-color: #F5BE41;
	}
	.room_no{
		height: 33px;
		background-color: #E6EFFD;
	}
	.room_zt_xw{
		margin-top: 25px;
	}
	::v-deep .is-selected{
		background-color: #409EFF !important;
		color: #fff !important;
	}
</style>